import { useQueryClient } from "@tanstack/react-query";

import { api } from "../../../utils/axios/Config";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import ShowMoreText from "../../shared/show-more";

const NotifCard = ({ item }) => {
  const { seen_by_current_user, notification } = item || {};
  const { title, content, creation_time, id } = notification || {};
  const queryClient = useQueryClient();
  const handleSeenMessage = async (messageId) => {
    const response = await api.post(`/notifications/${messageId}/read/`);
    if (response.status === 200) {
      queryClient.invalidateQueries({ queryKey: ["getNotificationList"] });
    }
  };
  return (
    <div className="group relative  w-full">
      {!item?.seen_by_current_user && (
        <div className="absolute right-2 top-2 z-10">
          <div className="flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-full w-full animate-pulse  rounded-full bg-primary-90 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 items-center justify-center rounded-full bg-primary-50 text-[10px] font-bold text-white"></span>
          </div>
        </div>
      )}

      <div className="relative overflow-hidden rounded-xl bg-gradient-to-bl bg-white border p-[1px] shadow-md shadow-emerald-500/20 ">
        {!item?.seen_by_current_user ? (
          <div
            onClick={() => handleSeenMessage(item?.notification?.id)}
            className="z-[9999] absolute top-2 left-2 "
          >
            <img src="/images/eye-plus.svg" alt="" className="h-6 w-6" />
          </div>
        ) : (
          <img src="/images/seen.svg" alt="" className="h-6 w-6 z-[9999] absolute top-2 left-2" />
        )}

        <div className="flex flex-col gap-2 px-6 py-3">
          <span className="text-sm font-semibold">{title}</span>
          <ShowMoreText
            lines={2}
            more="نمایش بیشتر"
            less="نمایش کمتر"
            className="p-2 text-[12px] font-medium break-words text-slate-800  "
            anchorClass="text-blue-600 cursor-pointer text-[10px]"
          >
            {content || ""}
          </ShowMoreText>
        </div>

        <div className="flex gap-1 items-center text-neutral-60 text-[10px] justify-end pt-2  w-fit mr-auto px-2">
          <p>{unixToPersianDay(item?.notification?.creation_time)}</p> -
          <p>{unixToPersianTime(item?.notification?.creation_time)}</p>
        </div>
      </div>
    </div>
  );
};

export default NotifCard;
